module.exports = __webpack_public_path__ + "assets/Circle3.b365e3d8b434fbeaf1d1b7cfb4eee034.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Circle3.gmt
// module id = 914
// module chunks = 0